import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      if (response.data.success) {
        sessionStorage.setItem("adminToken", response.data.token);
        toast.success("Sikeres bejelentkezés");
        navigate("/admin/dashboard");
      }
    } catch (error) {
      toast.error("Hibás jelszó");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#030303] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-12">
          <a href="/" className="inline-flex items-center gap-3">
            <img src="/alpine-car-logo.png" alt="Alpine Car" className="w-14 h-14 rounded-2xl object-cover" />
            <span className="font-['Space_Grotesk'] text-2xl font-semibold tracking-tight text-white">
              Alpine Car
            </span>
          </a>
          <p className="text-white/40 mt-4 text-sm">Admin Panel</p>
        </div>

        {/* Login Form */}
        <div className="modern-card p-10">
          <div className="flex items-center justify-center mb-10">
            <div className="w-20 h-20 bg-[#D4AF37]/10 rounded-2xl flex items-center justify-center border border-[#D4AF37]/20">
              <Lock className="w-10 h-10 text-[#D4AF37]" />
            </div>
          </div>

          <form onSubmit={handleLogin} className="space-y-6" data-testid="admin-login-form">
            <div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Admin jelszó"
                required
                className="form-input text-center"
                data-testid="admin-password-input"
              />
            </div>
            <Button 
              type="submit"
              disabled={isLoading}
              className="w-full bg-[#D4AF37] text-black hover:bg-[#B8860B] rounded-full font-medium py-6 text-base btn-modern disabled:opacity-50"
              data-testid="admin-login-button"
            >
              {isLoading ? "Bejelentkezés..." : "Belépés"}
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </form>

          <div className="mt-8 text-center">
            <a href="/" className="text-white/40 text-sm hover:text-[#D4AF37] transition-colors">
              Vissza a főoldalra
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
